import { computed, makeObservable, observable } from 'mobx';

import { Cover } from '../../core/models/cover';
import { Address } from '../../lib/utils/address';
import { Asset, Shot, Project } from './';
import { Model } from '../../core/engine';
import { ManyToOne, OneToMany } from '../../core/engine/decorators';
import { formatAddress } from '../../core/services/address.service';

export class Location extends Model {
  name: string;
  address?: Address;
  contact?: string;
  cover?: Cover;
  requirements?: string;
  nearestParking?: string;
  nearestParkingPin?: string;

  nearestHospital?: string;

  nearestHospitalPin?: string;

  assetsFolderId?: string;

  @OneToMany('location')
  shots: Shot[] = [];

  /** The location's assets **/
  @OneToMany('location')
  assets: Asset[] = [];

  projectId: string;

  @ManyToOne('locations')
  public project: Project | null = null;

  constructor() {
    super('locations');

    makeObservable(this, {
      assets: observable,
      cover: observable,
      address: observable,
      isSearchable: computed,
      formattedAddress: computed,
    });
  }

  get formattedAddress(): string {
    return this.address ? formatAddress(this.address) || '' : '';
  }

  get isSearchable() {
    return !!((this.address?.line1 || this.address?.line2) && this.address?.city);
  }

  async update(input: Partial<Omit<this, '_id'>>) {
    await super.update(input);
    Object.assign(this, input);
  }

  static getOne(id: string): Location | undefined {
    return Model.getOne(id) as Location;
  }

  toPOJO(): Record<string, any> {
    return {};
  }
}
